<div class="tokens-plan">
  <div class="tokens-plan_main">
    <div class="tokens-plan_type">
      <span class="tokens-plan_icon">{{ getPlanIcon(plan.title) }}</span>
      <span>{{ plan.title }}</span>
    </div>
    <div class="tokens-plan_amount">
      <div class="tokens-plan_amount__value">
        <p>
          <stxt-svg-icon [iconConfig]="tokensSvg" class="tokens-plan_amount__svg"></stxt-svg-icon>
          {{ plan.tokens_quantity }}
        </p>
        <div
          [ngClass]="{ 'tokens-plan_amount__save--selected': selectedPlan === plan.title }"
          class="tokens-plan_amount__save"
          *ngIf="plan.save !== '0%' && plan.save?.length"
        >
          SAVE {{ plan.save }}
        </div>
      </div>
      <div class="tokens-plan_price">
        <span class="per-token">
          {{ plan.price / 100 | currency }} • {{ plan?.price_per_token }}/token
        </span>
      </div>
    </div>
  </div>
  <div class="tokens-plan_radio">
    <div class="radio-outer" [ngClass]="{ 'radio-outer__selected': selectedPlan === plan.title }">
      <div
        class="radio-inner"
        [ngClass]="{ 'radio-inner__selected': selectedPlan === plan.title }"
      ></div>
    </div>
  </div>
</div>
